<script setup lang="ts">
    // import type { FulfillmentLookupError } from "common";
    import type { MaskInputOptions } from "maska";
    import { vMaska } from "maska/vue";
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const r$ = orderStore.validation.r$;

    const streetName = computed(() =>
        orderStore.meta.fulfillmentError === 2
            ? "Adres niet gevonden"
            : orderStore.meta.streetName,
    );

    const postalCodeMask = reactive<MaskInputOptions>({
        mask: "####AA",
        tokens: {
            A: {
                pattern: /[A-Z]/,
                transform: (chr: string) => chr.toUpperCase(),
            },
        },
    });

    const houseNumberInput = ref();

    onMounted(() => {
        if (!orderStore.currentOrder.fulfillment.deliver) return;

        houseNumberInput.value =
            orderStore.currentOrder.fulfillment.data.houseNumber +
            orderStore.currentOrder.fulfillment.data.houseNumberSuffix;
    });

    const houseNumberMask = reactive<MaskInputOptions>({
        mask: "#AAA",
        tokens: {
            "#": { pattern: /[0-9]/, multiple: true },
            A: {
                pattern: /[A-Z]/,
                transform: (chr: string) => chr.toUpperCase(),
                optional: true,
            },
        },
        onMaska(detail) {
            if (!orderStore.currentOrder.fulfillment.deliver) return;

            const houseNumber = parseInt(detail.masked.replace(/[^0-9]/g, ""));
            const houseNumberSuffix = detail.unmasked.replace(/[^A-Z]/g, "");

            orderStore.currentOrder.fulfillment.data.houseNumber = isNaN(
                houseNumber,
            )
                ? undefined
                : houseNumber;
            orderStore.currentOrder.fulfillment.data.houseNumberSuffix =
                houseNumberSuffix;
        },
    } as MaskInputOptions);

    const fulfillment = orderStore.currentOrder.fulfillment;
</script>
<template>
    <template v-if="fulfillment.deliver">
        <shared-labeled-field v-slot="{ ariaLabelledby }" label="Adresgegevens">
            <span class="d-flex flex-row flex-wrap ga-3">
                <VTextField
                    v-model="fulfillment.data.postalCode"
                    v-maska="postalCodeMask"
                    style="min-width: 10rem"
                    prepend-inner-icon="mdi-map-marker"
                    :aria-labelledby="ariaLabelledby"
                    placeholder="Postcode"
                    :error-messages="r$.$errors.fulfillment.data.postalCode"
                    @focusout="r$.$fields.fulfillment.data.postalCode?.$touch"
                />
                <VTextField
                    v-model="houseNumberInput"
                    v-maska="houseNumberMask"
                    class="flex-shrink-1"
                    style="min-width: 5rem"
                    :aria-labelledby="ariaLabelledby"
                    placeholder="Huisnummer"
                    :error-messages="r$.$errors.fulfillment.data.houseNumber"
                    @focusout="r$.$fields.fulfillment.data.houseNumber?.$touch"
                />
                <VTextField
                    class="flex-grow-1"
                    style="min-width: 15rem"
                    :value="streetName"
                    :aria-labelledby="ariaLabelledby"
                    :loading="orderStore.meta.loadingFulfillment"
                    readonly
                    placeholder="Straatnaam - automatisch aangevuld"
                />
            </span>
        </shared-labeled-field>
        <template v-if="orderStore.meta.fulfillmentError !== undefined">
            <template v-if="orderStore.meta.fulfillmentError == 1">
                <VAlert type="error">
                    {{ $t("checkout.location.allTimeslotsFull") }}
                </VAlert>
            </template>
            <template v-if="orderStore.meta.fulfillmentError == 3">
                <VAlert type="error">
                    {{ $t("checkout.location.unsupportedLocation") }}
                </VAlert>
            </template>
            <template v-else-if="orderStore.meta.fulfillmentError == 0">
                <VAlert type="error">
                    <!-- TODO: Localize -->
                    Er is een probleem ontstaan bij het ophalen van uw adres
                </VAlert>
            </template>
        </template>
    </template>
</template>
